export enum EVENT {
  REQUEST = '@@ZENTITY/TRANSLATE/REQUEST',
  RECEIVED = '@@ZENTITY/TRANSLATE/RECEIVED',
  REQUEST_NEW = '@@ZENTITY/TRANSLATE/REQUEST_NEW',
  RECEIVED_NEW = '@@ZENTITY/TRANSLATE/RECEIVED_NEW',
  FAILED = '@@ZENTITY/TRANSLATE/FAILED',
}
